export default "__VITE_ASSET__DmKXQP8i__"